var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
const StyledButton = styled(Button) `
    min-width: 78px;
    height: 36px;
    border-radius: 4px;
    padding: 4px;
    margin-right: 8px;
`;
const StyledTypography = styled(Typography) `
    color: white;
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.4px;
    white-space: nowrap;
`;
export const LeaveButton = (props) => {
    const { label } = props, rest = __rest(props, ["label"]);
    return (_jsx(StyledButton, Object.assign({ variant: 'contained', color: 'error' }, rest, { children: _jsx(StyledTypography, { component: 'span', children: label }) })));
};
